import React from 'react';
import { Styles } from '../../../config/design/styles';
import AppAnimate from "../../components/AppAnimate";
import Wallet from "./Wallet";
import Grid from "@mui/material/Grid2";
import { withStyles } from "@mui/styles";
import Title from "../../components/elements/Title";
import Wallets from "../manage/wallets/Wallets";
import {useTranslation} from "react-i18next";

const WalletPage = ({ classes }) => {
    const { t } = useTranslation();

    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={t('myTransactions')}>
            <Grid container spacing={2} justify="center">
                <Grid item size={12}>
                    <Title align="left" color="text" className="panel-title">{t('myTransactions')}</Title>
                    <Wallet />
                </Grid>
            </Grid>
        </AppAnimate>
    );
};

export default withStyles(Styles)(WalletPage);
